export default __webpack_public_path__ + "static/media/a_wdt_c_3_4.a44de113.mp3";